import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SideMenu from './Components/CspMapping/SideMenu';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { getAllRequest } from 'API/CspMapping/api';
import SnackBar from './Components/General/SnackBar';
import BackdropLoader from './Components/General/Loader';



const CspMappingRequest = () => {


    const [activeStep,setActiveStep]=useState(0)
    const [RequestData, setRequestData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(null)
    const [AlertType, setAlertType] = useState("success")
    const [AlertMessage, setAlertMessage] = useState("")




    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setOpenAlert(true)
    }



    useEffect(() => {
        if(activeStep===0){

            getAllRequest(setIsLoading, setRequestData, handleAlertOpen,"pending")
        }
        else if(activeStep===1){
            getAllRequest(setIsLoading, setRequestData, handleAlertOpen,"approved")

        }
        else{
            getAllRequest(setIsLoading, setRequestData, handleAlertOpen,"rejected")

        }
    }, [activeStep])


    console.log("data", RequestData);


    return (
        <Box>
            <BackdropLoader open={isLoading} />
            <SnackBar open={openAlert} handleClose={handleAlertClose} type={AlertType} message={AlertMessage} />
            <MainCard sx={{ height: '100%', overflowX: 'scroll' }}>
                <SideMenu setActiveStep={setActiveStep} data={RequestData} />
            </MainCard>
        </Box>
    )
}

export default CspMappingRequest